var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NewFile',{attrs:{"boxHeight":_vm.boxHeight,"multiple":false,"message":_vm.message,"accepted":_vm.allowedFileTypes,"fileName":_vm.fileName,"basePath":_vm.basePath},on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }